var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-rich-text"},[_c('div',{staticClass:"title font-semibold"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"content quote typo",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }